import type { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/components/Tooltip';

import style from './style.scss';

interface Props {
  status: 'open' | 'close';
  collapsed: boolean;
}

const pillClassNameMap = {
  open: style.pill_open,
  close: style.pill_close
};

const messageKeyMap = {
  open: 'common-websocket_connected',
  close: 'common-websocket_disconnected'
};

const RealtimeIndicator: FC<Props> = ({ status, collapsed }) => {
  const [t] = useTranslation();

  if (collapsed) {
    return (
      <div className={`${style.container} ${style.container_collapsed}`}>
        <Tooltip
          content={t(messageKeyMap[status])}
          offset={{ x: 50, y: 0 }}
          withoutArrow
          withPortal
        >
          <div className={classnames(style.pill, pillClassNameMap[status])} />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={style.container}>
      <div className={classnames(style.pill, pillClassNameMap[status])} />
      <div className={style.message}>{t(messageKeyMap[status])}</div>
    </div>
  );
};

RealtimeIndicator.displayName = 'RealtimeIndicator';

export default RealtimeIndicator;
